import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { MarketId } from 'src_common/common/websocket2/id/WebsocketId';
import {
    BreadcrumbRow,
    ChevronLeftButton,
    MetaRacePlace,
    RaceMeta,
    SectionHeader,
    SectionHeaderColumn,
    SectionHeaderColumnWrapper,
} from 'src/domains/sportsbook/webview/components/raceSummary/specials/HeaderMeta.style';
import { DateTime } from 'src_common/utils/time/time';

interface HeaderMetaSpecialsPropsType {
    marketId: MarketId;
    closeEvent: () => void;
}

/** @description _Header meta data for **Specials** section_ */
export const HeaderMetaSpecials = observer('HeaderMetaSpecials', (props: HeaderMetaSpecialsPropsType) => {
    const { marketId, closeEvent } = props;

    const marketModel = marketId.getModel();

    if (marketModel === null) {
        return null;
    }

    const eventModel = marketModel.getEvent();
    if (eventModel === null) {
        return null;
    }

    const raceName = eventModel.name.trim();

    const dateTime = DateTime.from(eventModel.timeSettingsStartTime);
    const formattedDate = dateTime?.format('DD MMM YYYY') ?? '';

    return (
        <SectionHeader>
            <BreadcrumbRow>
                <ChevronLeftButton
                    position='left'
                    onClick={closeEvent}
                />

                <SectionHeaderColumnWrapper>
                    {raceName !== '' && <MetaRacePlace>{raceName}</MetaRacePlace>}

                    <SectionHeaderColumn>
                        {formattedDate !== '' && <RaceMeta>{formattedDate}</RaceMeta>}
                    </SectionHeaderColumn>
                </SectionHeaderColumnWrapper>
            </BreadcrumbRow>
        </SectionHeader>
    );
});
